// import React, { useEffect,useState } from "react";
// import { FiCheck, FiFileText } from "react-icons/fi";
// import { sanctionLetterDataUrl,sanctionLetterViewUrl } from "../../config/taskApi";

// const getSessionData = () => {
//   try {
//     const keys = Object.keys(sessionStorage);

//     for (const key of keys) {
//       const value = sessionStorage.getItem(key);

//       if (!value) continue;

//       try {
//         const parsed = JSON.parse(value);

//         if (parsed && parsed.lead_id) {
//           return parsed;
//         }
//       } catch {
//         // Ignore non-JSON session values
//       }
//     }

//     return null;
//   } catch {
//     return null;
//   }
// };
// const SectionLetterPage = ({ setScreen }) => {
//     const sessionData = getSessionData();
//   // const leadId = sessionData?.lead_id || "";
//   const leadId =13695

//   console.log("Section Letter Lead ID:", leadId);

// const [sectionLetterLoading, setSectionLetterLoading] = useState(false);
//   const [sectionLetterMessage, setSectionLetterMessage] = useState("");
// const [sectionLetterView, setSectionLetterView] = useState("");
// const [sectionLetterViewLoading, setSectionLetterViewLoading] = useState(true);
// useEffect(() => {
//   const fetchSectionLetterView = async () => {
//     try {
//       setSectionLetterViewLoading(true);

//       const formData = new URLSearchParams();
//       formData.append("lead_id", leadId);

//       const response = await fetch(sanctionLetterViewUrl(), {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/x-www-form-urlencoded",
//         },
//         body: formData.toString(),
//       });

//       const html = await response.text();

//       console.log("Section Letter View Response:", html);

//       setSectionLetterView(html);
//     } catch (error) {
//       console.error("Section Letter View API Error:", error);

//       setSectionLetterView("");
//     } finally {
//       setSectionLetterViewLoading(false);
//     }
//   };

//   if (leadId) {
//     fetchSectionLetterView();
//   }
// }, [leadId]);
// // const handleAcceptAndContinue = async () => {
// //   if (!leadId || sectionLetterLoading) {
// //     return;
// //   }

// //   try {
// //     setSectionLetterLoading(true);

// //     const formData = new URLSearchParams();
// //     formData.append("lead_id", leadId);

// //     const response = await fetch(sanctionLetterDataUrl(), {
// //       method: "POST",
// //       headers: {
// //         "Content-Type": "application/x-www-form-urlencoded",
// //       },
// //       body: formData.toString(),
// //     });

// //     const data = await response.json();

// //     console.log("Section Letter API Response:", data);

// //     const status =
// //       data?.status === 1 ||
// //       data?.status === true ||
// //       data?.status === "1";

// //     // const message =
// //     //   data?.response?.message ||
// //     //   data?.message ||
// //     //   "Section Letter request processed.";

// //     const message =
// //   data?.msg ||
// //   "Section Letter request processed.";

// //     sessionStorage.setItem(
// //       "sectionLetterApiResult",
// //       JSON.stringify({
// //         status,
// //         message,
// //       })
// //     );

// //     setScreen("/apply-new/disbursementProcessing");
// //   } catch (error) {
// //     console.error("Section Letter API Error:", error);

// //     sessionStorage.setItem(
// //       "sectionLetterApiResult",
// //       JSON.stringify({
// //         status: false,
// //         message: error?.message || "Section Letter request failed.",
// //       })
// //     );

// //     setScreen("/apply-new/disbursementProcessing");
// //   } finally {
// //     setSectionLetterLoading(false);
// //   }
// // };
// const handleAcceptAndContinue = async () => {
//   if (!leadId || sectionLetterLoading) {
//     return;
//   }

//   try {
//     setSectionLetterLoading(true);
//     setSectionLetterMessage("");

//     const formData = new URLSearchParams();
//     formData.append("lead_id", leadId);

//     const response = await fetch(sanctionLetterDataUrl(), {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/x-www-form-urlencoded",
//       },
//       body: formData.toString(),
//     });

//     const data = await response.json();

//     console.log("Section Letter API Response:", data);

//     // const status = data?.status === true;
//     const status =
//   data?.status === true ||
//   data?.status === 1 ||
//   data?.status === "1" ||
//   data?.status === "true";

// console.log("FULL API RESPONSE:", data);
// console.log("STATUS FROM API:", data?.status);
// console.log("STATUS AFTER CHECK:", status);

//     const message =
//       data?.msg || "Section Letter request processed.";

//     // if (status) {
//     //   sessionStorage.setItem(
//     //     "sectionLetterApiResult",
//     //     JSON.stringify({
//     //       status: true,
//     //       message: message,
//     //     })
//     //   );

//     //   setScreen("/apply-new/disbursementProcessing");
//     // } else {
//     //   setSectionLetterMessage(message);
//     // }

//     if (status) {
//   console.log("STATUS TRUE - NAVIGATING");

//   sessionStorage.setItem(
//     "sectionLetterApiResult",
//     JSON.stringify({
//       status: true,
//       message: message,
//     })
//   );

//   setScreen("/apply-new/loanInProgress");
// } else {
//   console.log("STATUS FALSE - NOT NAVIGATING");

//   setSectionLetterMessage(message);
// }
//   } catch (error) {
//     console.error("Section Letter API Error:", error);

//     setSectionLetterMessage(
//       error?.message || "Section Letter request failed."
//     );
//   } finally {
//     setSectionLetterLoading(false);
//   }
// };  

// return (  
//     <section className="fw-screen fw-screen--section-letter fw-fade">
//       <div className="fw-section-letter__header">
//         <div className="fw-section-letter__icon">
//           <FiFileText />
//         </div>
// <div>
//   <button
//     type="button"
//     onClick={() => setScreen("/apply-new/processBank")}
//   >
//     Temp to go back "proceed bank "
//   </button>
// </div>

//         <h1 className="fw-title">Sanction Letter</h1>

//         <p className="fw-sub">
//           Please review the section letter carefully before accepting.
//         </p>
//       </div>

//       {/* <div className="fw-section-letter__document">
//         <div className="fw-section-letter__document-head">
//           <strong>LOAN SECTION LETTER</strong>
//           <span>Demo Document</span>
//         </div>

//         <div className="fw-section-letter__body">
//           <p>
//             Dear Customer,
//           </p>

//           <p>
//             We are pleased to inform you that your loan application has been
//             approved and is now ready for the next stage of disbursement.
//           </p>

//           <div className="fw-section-letter__details">
//             <div>
//               <span>Applicant Name</span>
//               <strong>Customer Name</strong>
//             </div>

//             <div>
//               <span>Loan Amount</span>
//               <strong>₹23,800</strong>
//             </div>

//             <div>
//               <span>Tenure</span>
//               <strong>35 Days</strong>
//             </div>

//             <div>
//               <span>Loan Purpose</span>
//               <strong>Personal Requirement</strong>
//             </div>
//           </div>

//           <p>
//             By accepting this section letter, you confirm that you have
//             reviewed the above information and agree to proceed with the
//             disbursement process.
//           </p>

//           <p>
//             This is a demo section letter. The final content will be populated
//             dynamically from the Section Letter API.
//           </p>
//         </div>
//       </div> */}
//       {sectionLetterViewLoading ? (
//   <div className="fw-section-letter__document">
//     <p style={{ textAlign: "center", padding: "30px" }}>
//       Loading Section Letter...
//     </p>
//   </div>
// ) : sectionLetterView ? (
//   <iframe
//     title="Section Letter"
//     srcDoc={sectionLetterView}
//     style={{
//       width: "100%",
//       minHeight: "700px",
//       border: "none",
//       background: "#fff",
//     }}
//   />
// ) : (
//   <div className="fw-section-letter__document">
//     <p style={{ textAlign: "center", padding: "30px" }}>
//       Unable to load Section Letter.
//     </p>
//   </div>
// )}

//       <div className="fw-section-letter__consent">
//         <FiCheck />
//         <span>
//           I have read and agree to the Section Letter.
//         </span>
//       </div>

//       <div className="fw-actions fw-section-letter__actions">
//         <button
//           type="button"
//           className="fw-btn fw-btn--primary fw-btn--full"
//           // onClick={() => setScreen("/apply-new/disbursementProcessing")}
//           onClick={handleAcceptAndContinue}
//           disabled={sectionLetterLoading}
//         >
//         {sectionLetterLoading ? "Processing..." : "Accept & Continue"}
//         </button>
//       </div>
//     </section>
//   );
// };



// export default SectionLetterPage;



import React, { useEffect, useState } from "react";
import { FiFileText } from "react-icons/fi";
import {
  sanctionLetterDataUrl,
  sanctionLetterViewUrl,
} from "../../config/taskApi";

const getSessionData = () => {
  try {
    const keys = Object.keys(sessionStorage);

    for (const key of keys) {
      const value = sessionStorage.getItem(key);

      if (!value) continue;

      try {
        const parsed = JSON.parse(value);

        if (parsed && parsed.lead_id) {
          return parsed;
        }
      } catch {
        // Ignore non-JSON session values
      }
    }

    return null;
  } catch {
    return null;
  }
};

const SectionLetterPage = ({ setScreen }) => {
  const sessionData = getSessionData();

  const leadId = sessionData?.lead_id || "";
  // const leadId =
  // sessionData?.aa_lead_id ||
  // sessionData?.bankBreResponse?.data?.lead_id ||
  // sessionData?.lead_id ||
  // "";
  
  // const leadId = 13695;

  console.log("Section Letter Lead ID:", leadId);

  // Section Letter view
  const [sectionLetterView, setSectionLetterView] = useState("");
  const [sectionLetterViewLoading, setSectionLetterViewLoading] =
    useState(true);

  // Accept API
  const [sectionLetterLoading, setSectionLetterLoading] =
    useState(false);

  const [sectionLetterMessage, setSectionLetterMessage] =
    useState("");

  // Real checkbox state
  const [isConsentChecked, setIsConsentChecked] =
    useState(false);

  // =========================================================
  // SECTION LETTER VIEW API
  // =========================================================

  useEffect(() => {
    const fetchSectionLetterView = async () => {
      if (!leadId) {
        console.error("Section Letter Lead ID is missing.");

        setSectionLetterView("");
        setSectionLetterViewLoading(false);
        return;
      }

      try {
        setSectionLetterViewLoading(true);

        const formData = new URLSearchParams();

        formData.append("lead_id", String(leadId));

        const response = await fetch(
          sanctionLetterViewUrl(),
          {
            method: "POST",
            headers: {
              "Content-Type":
                "application/x-www-form-urlencoded",
            },
            body: formData.toString(),
          }
        );

        const html = await response.text();

        console.log(
          "Section Letter View Response:",
          html
        );

        if (!response.ok) {
          throw new Error(
            `Section Letter view failed: ${response.status}`
          );
        }

        if (!html.trim()) {
          throw new Error(
            "Section Letter document is empty."
          );
        }

        /*
         * Backend returns complete HTML document.
         *
         * We inject responsive CSS so that the
         * 720px backend document fits properly
         * inside the mobile UI.
         */
        const responsiveHtml = html.replace(
          "</head>",
          `
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1.0"
            />

            <style>
              html,
              body {
                width: 100% !important;
                max-width: 100% !important;
                margin: 0 !important;
                padding: 0 !important;
                background: #ffffff !important;
                overflow-x: hidden !important;
              }

              body {
                font-family: Arial, Helvetica, sans-serif;
                box-sizing: border-box;
              }

              .page-container {
                width: 100% !important;
                max-width: 720px !important;
                min-height: auto !important;
                margin: 0 auto !important;
                padding: 18px 16px !important;
                box-shadow: none !important;
                box-sizing: border-box !important;
                background: #ffffff !important;
              }

              table {
                max-width: 100% !important;
              }

              .kfs-table,
              .terms-table {
                width: 100% !important;
                max-width: 100% !important;
                table-layout: fixed !important;
              }

              td {
                word-break: break-word !important;
                overflow-wrap: anywhere !important;
              }

              img {
                max-width: 100% !important;
                height: auto !important;
              }

              p {
                word-break: break-word !important;
              }

              @media (max-width: 600px) {
                .page-container {
                  padding: 14px 10px !important;
                }

                .header-title {
                  font-size: 15pt !important;
                }

                .kfs-table {
                  font-size: 9px !important;
                }

                .terms-table {
                  font-size: 8.5px !important;
                }

                p,
                li {
                  font-size: 9px !important;
                  line-height: 1.35 !important;
                }
              }
            </style>
          </head>
        `
        );

        setSectionLetterView(responsiveHtml);
      } catch (error) {
        console.error(
          "Section Letter View API Error:",
          error
        );

        setSectionLetterView("");
      } finally {
        setSectionLetterViewLoading(false);
      }
    };

    fetchSectionLetterView();
  }, [leadId]);

  // =========================================================
  // ACCEPT & CONTINUE API
  // =========================================================

  const handleAcceptAndContinue = async () => {
    if (!leadId) {
      setSectionLetterMessage(
        "Lead ID is missing. Please try again."
      );
      return;
    }

    if (!isConsentChecked) {
      setSectionLetterMessage(
        "Please confirm that you have read and agree to the Section Letter."
      );
      return;
    }

    if (sectionLetterLoading) {
      return;
    }

    try {
      setSectionLetterLoading(true);
      setSectionLetterMessage("");

      const formData = new URLSearchParams();

      // Only lead_id is sent
      formData.append("lead_id", String(leadId));

      const response = await fetch(
        sanctionLetterDataUrl(),
        {
          method: "POST",
          headers: {
            "Content-Type":
              "application/x-www-form-urlencoded",
          },
          body: formData.toString(),
        }
      );

      /*
       * sanctionlatterdata API is returning JSON.
       */
      const data = await response.json();

      console.log(
        "Section Letter API Response:",
        data
      );

      const status =
        data?.status === true ||
        data?.status === 1 ||
        data?.status === "1" ||
        data?.status === "true";

      const message =
        data?.msg ||
        "Section Letter request processed.";

      console.log(
        "STATUS FROM API:",
        data?.status
      );

      console.log(
        "STATUS AFTER CHECK:",
        status
      );

      if (status) {
        console.log(
          "STATUS TRUE - NAVIGATING"
        );

        sessionStorage.setItem(
          "sectionLetterApiResult",
          JSON.stringify({
            status: true,
            message,
          })
        );

        setScreen(
          "/apply-new/loanInProgress"
        );

        return;
      }

      console.log(
        "STATUS FALSE - STAYING ON SECTION LETTER"
      );

      setSectionLetterMessage(message);
    } catch (error) {
      console.error(
        "Section Letter API Error:",
        error
      );

      setSectionLetterMessage(
        error?.message ||
          "Section Letter request failed. Please try again."
      );
    } finally {
      setSectionLetterLoading(false);
    }
  };

  return (
    <section className="fw-screen fw-screen--section-letter fw-fade">

      {/* =====================================================
          HEADER
      ===================================================== */}

      <div className="fw-section-letter__header">

        <div className="fw-section-letter__icon">
          <FiFileText />
        </div>

        {/* Temporary Back Button */}
        <div>
          <button
            type="button"
            onClick={() =>
              setScreen("/apply-new/processBank")
            }
          >
            Temp to go back "proceed bank"
          </button>
        </div>

        <h1 className="fw-title">
          Sanction Letter
        </h1>

        <p className="fw-sub">
          Please review the section letter carefully
          before accepting.
        </p>
      </div>

      {/* =====================================================
          SECTION LETTER VIEWER
      ===================================================== */}

      <div className="fw-section-letter__viewer">

        {sectionLetterViewLoading ? (
          <div className="fw-section-letter__loading">
            Loading Section Letter...
          </div>
        ) : sectionLetterView ? (
          <iframe
            title="Section Letter"
            srcDoc={sectionLetterView}
            className="fw-section-letter__iframe"
          />
        ) : (
          <div className="fw-section-letter__loading">
            Unable to load Section Letter.
          </div>
        )}

      </div>

      {/* =====================================================
          API ERROR / FALSE STATUS MESSAGE
      ===================================================== */}

      {sectionLetterMessage && (
        <div className="fw-section-letter__message">
          {sectionLetterMessage}
        </div>
      )}

      {/* =====================================================
          CONSENT CHECKBOX
      ===================================================== */}

      <label className="fw-section-letter__consent">
        <input
          type="checkbox"
          checked={isConsentChecked}
          onChange={(event) => {
            setIsConsentChecked(
              event.target.checked
            );

            // Error message hata do jab user checkbox tick kare
            if (event.target.checked) {
              setSectionLetterMessage("");
            }
          }}
        />

        <span className="fw-section-letter__checkbox">
          {isConsentChecked ? "✓" : ""}
        </span>

        <span>
          I have read and agree to the Section Letter.
        </span>
      </label>

      {/* =====================================================
          ACCEPT BUTTON
      ===================================================== */}

      <div className="fw-actions fw-section-letter__actions">

        <button
          type="button"
          className="fw-btn fw-btn--primary fw-btn--full"
          onClick={handleAcceptAndContinue}
          disabled={
            sectionLetterLoading ||
            sectionLetterViewLoading ||
            !isConsentChecked
          }
        >
          {sectionLetterLoading
            ? "Processing..."
            : "Accept & Continue"}
        </button>

      </div>

    </section>
  );
};

export default SectionLetterPage;